

export class HomepageDetails {
  pageTitle:string = '';
  eventTitle:string = '';
  weeklyEconomicSummary:string = '';
  currencyExchangeTitle:string = '';

}

export class HomepageModel {
  flatData: HomepageDetails = new HomepageDetails();
}